import React from "react";
import styled from "styled-components";
import { HighlightedItem } from "./Header";
import { ButtonVariant } from "../utils/types";
import { Box, Flex, Icon, Text } from "@thenounproject/lingo-core";
import { COLORS, MARKETING_BP_MD } from "../utils/constants";
import { MarketingButton } from "../buttons";
import { HIGHLIGHTED_SECTION_WIDTH } from "./constants";

const HighlightedSection = styled(Flex)`
  background: ${COLORS.gray};
  border-radius: 20px;
  padding: 36px 44px;
  width: 100%;
  max-width: ${HIGHLIGHTED_SECTION_WIDTH}px;
  margin: 0 auto 32px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  z-index: 1000;

  @media (max-width: ${MARKETING_BP_MD}) {
    flex-direction: column;
    align-items: flex-start;
    min-width: 343px;
    height: 257px;
    padding: 24px 44px;
    position: sticky;
    bottom: 20px;
    box-shadow: 0px 4px 24px 0px #00000040;
    margin-left: -20px;
  }
`;

const HighlightedContent = styled(Flex)`
  align-items: center;
  gap: 24px;
  flex: 1;

  @media (max-width: ${MARKETING_BP_MD}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const HighlightedText = styled(Box)`
  flex: 1;
`;

type Props = {
  item: HighlightedItem;
  variant?: ButtonVariant;
};

const HighlightedItemComponent = ({ item, variant = "outlineBlue" }: Props) => (
  <HighlightedSection>
    <HighlightedContent>
      {item.icon && (
        <Box background="primary" p="12px" borderRadius="50%">
          <Icon iconId={item.icon} size={32} fill="white" />
        </Box>
      )}
      {item.image && (
        <Box
          borderRadius="10px"
          width="150px"
          height="100px"
          variations={{
            "mq.m": {
              width: "100px",
              height: "67px",
            },
          }}>
          <img src={item.image.src} alt={item.image.alt} />
        </Box>
      )}
      <HighlightedText>
        <Text font="marketing.h5" color={COLORS.blue}>
          {item.title}
        </Text>
        {item.subtitle && <Text font="marketing.navLink">{item.subtitle}</Text>}
      </HighlightedText>
    </HighlightedContent>
    <MarketingButton href={item.button.link} variant={variant}>
      {item.button.text}
    </MarketingButton>
  </HighlightedSection>
);

export default HighlightedItemComponent;
